export const withView = (query: string, view: string | null): string => {
    const params = new URLSearchParams(query);

    if (view) {
        params.set('view', view);
    } else {
        params.delete('view');
    }

    return params.toString();
};
